import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Context } from "../../../context/Context";
import { fetchCatalogRequestsAPI } from "../../../utils/api/actions";

// Operations requests made from catalog campaigns, grouped by campaign.
// `byCampaign[catalogEntryId]` is the list of restaurants' requests (each with
// its current Operations status). Nothing here is derived or cached beyond
// what the API returned, so the Campaigns page cannot disagree with
// Operations.
export function useCatalogRequests(enabled) {
  const { handleTokenExpiration } = useContext(Context);
  const [state, setState] = useState({ actions: [], loading: false, failed: false });
  const [tick, setTick] = useState(0);
  const expiredRef = useRef(handleTokenExpiration);
  expiredRef.current = handleTokenExpiration;

  useEffect(() => {
    if (!enabled) return undefined;
    const token = localStorage.getItem("auth-token");
    if (!token) {
      expiredRef.current();
      return undefined;
    }
    let active = true;
    setState((prev) => ({ ...prev, loading: true }));
    fetchCatalogRequestsAPI(token).then((actions) => {
      if (!active) return;
      setState(actions ? { actions, loading: false, failed: false } : { actions: [], loading: false, failed: true });
    });
    return () => {
      active = false;
    };
  }, [enabled, tick]);

  const byCampaign = useMemo(() => {
    const groups = {};
    state.actions.forEach((action) => {
      if (!action.catalogEntryId) return;
      (groups[action.catalogEntryId] = groups[action.catalogEntryId] || []).push(action);
    });
    return groups;
  }, [state.actions]);

  const reload = useCallback(() => setTick((value) => value + 1), []);
  return { byCampaign, loading: state.loading, failed: state.failed, reload };
}
